import { Box, Button, Divider, Stack, TextField, Typography } from '@mui/material'
import { ChangeEvent, FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../../store'
import { CurrentUserActions } from '../../../../store/currentUser'
import { SnackbarActions } from '../../../../store/snackbar'

interface FundingAmountFormProps {
  currentAmount: string
  onClose: () => void
}

export const FundingAmountForm: FC<FundingAmountFormProps> = ({ currentAmount, onClose }) => {
  const dispatch = useDispatch<AppDispatch>()

  const [fundingAmount, setFundingAmount] = useState(currentAmount)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value

    if (value.trim() === '') {
      setFundingAmount('')
      return
    }

    if (/^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/.test(value)) {
      setFundingAmount(value)
    }
  }

  const handleSubmit = async () => {
    try {
      const goals = {
        funding: parseInt(fundingAmount),
      }

      const resultAction = await dispatch(
        CurrentUserActions.updateCurrentUserCompanyAsync({ goals }),
      )

      if (CurrentUserActions.updateCurrentUserCompanyAsync.fulfilled.match(resultAction)) {
        dispatch(
          SnackbarActions.showSnackbar({
            message: 'funding goal updated!',
            options: { variant: 'success' },
          }),
        )
      }

      dispatch(CurrentUserActions.fetchCurrentUserCompanyAsync())

      onClose()
    } catch (error: any) {
      dispatch(
        SnackbarActions.showSnackbar({
          message: error.message,
        }),
      )
    }
  }

  return (
    <Box py={2} position="relative" height="100%" border="1px solid black" px={2}>
      <Typography color="secondary" fontSize="1.3rem" fontWeight={600}>
        Edit Goal
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Box>
        <Typography mb={0.5} fontSize="14px" fontWeight={500} color="secondary.dark">
          Funding goal for the year
        </Typography>

        <TextField
          required
          fullWidth
          type="tel"
          variant="outlined"
          name="fundingAmount"
          value={fundingAmount}
          onChange={handleChange}
          placeholder="input funding goal"
          inputProps={{
            input: {
              sx: { borderRadius: '6px' },
            },
          }}
        />
      </Box>

      <Stack sx={{ position: 'absolute', bottom: 15 }} width="95%" direction="row" gap={2}>
        <Button
          fullWidth
          color="secondary"
          variant="outlined"
          onClick={onClose}
          sx={{ height: '46px', borderRadius: '8px', textTransform: 'none' }}
        >
          Cancel
        </Button>
        <Button
          fullWidth
          color="primary"
          variant="contained"
          onClick={handleSubmit}
          sx={{ height: '46px', borderRadius: '8px', textTransform: 'none' }}
        >
          Save
        </Button>
      </Stack>
    </Box>
  )
}
